import { z } from 'zod';

import { type IEndpointSchema, makeEndpoint } from '../common';

const BulkUpdateVibeSchema = z.object({
  id: z.string().uuid().optional().nullable(),
  name: z.string(),
  order: z.number(),
});

export type IBulkUpdateVibeSchema = z.infer<typeof BulkUpdateVibeSchema>;
export const UpdateVibesDataSchema = z.object({
  vibes: z.array(BulkUpdateVibeSchema),
});

export const UpdateVibesEndpoint = makeEndpoint({
  method: 'PATCH',
  url: ({ brandId }: { brandId: string }) => `v1/brands/${brandId}/vibes`,
  responseSchema: z.void(),
  requestSchema: UpdateVibesDataSchema,
});

export type IUpdateVibesEndpoint = IEndpointSchema<typeof UpdateVibesEndpoint>;
